// ─── DeleteRoleModal.tsx ──────────────────────────────────────────────────────

import React, { useState } from 'react';
import InfoModal from './InfoModal';
import './DeleteRoleModal.css';

type OrgRole = {
    id:          string;
    orgID:       string;
    name:        string;
    description: string;
    permissions: string[];
    isSystem:    boolean;
    isDefault:   boolean;
    createdBy:   string;
    dateCreated: string;
    dateUpdated: string;
};

type DeleteRoleModalProps = {
    roleObj:  OrgRole;
    isOpen:   boolean;
    onClose:  () => void;
    // FIX: was (roleID: RoleObj) — correct signature matches parent's onDeleteRBAC
    onDelete: (roleID: string) => Promise<void>;
};

export default function DeleteRoleModal({ roleObj, isOpen, onClose, onDelete }: DeleteRoleModalProps) {
    const [deleteText, setDeleteText] = useState('');
    const [deleting, setDeleting]     = useState(false);
    const [error, setError]           = useState<{ title: string; message: string } | null>(null);

    if (!isOpen) return null;

    const handleDelete = async () => {
        // FIX: was roleObj.defaultRole (field doesn't exist) — correct field is roleObj.isSystem
        // FIX: was roleObj.role (field doesn't exist) — correct field is roleObj.name
        // FIX: != replaced with !==
        if (!roleObj || roleObj.isSystem || deleteText !== roleObj.name) return;

        setDeleting(true);
        setError(null);
        try {
            // FIX: was passing the whole RoleObj — correct is passing roleObj.id string
            await onDelete(roleObj.id);
            // parent sets showDeleteRolePopup = false on success
        } catch (err: any) {
            setError({
                title:   err.title   || 'Role Not Deleted',
                message: err.message || "That role couldn't be deleted. Please try again.",
            });
            setDeleting(false);
        }
    };

    return (
        <div className="smrtdocs-modal-overlay">
            <div className="smrtdocs-modal" style={{ width: '480px' }}>
                <div className="smrtdocs-modal-header">
                    <h2 style={{ margin: 0, fontSize: '1rem' }}>Delete Role</h2>
                    <button className="btn-cancel" onClick={onClose} disabled={deleting}>Close</button>
                </div>
                <div className="smrtdocs-modal-body">
                    <p style={{ fontSize: '0.9rem', lineHeight: 1.5, margin: '0 0 12px', color: '#9aa0a6' }}>
                        Are you sure you want to delete <strong style={{ color: '#fff' }}>{roleObj.name}</strong>?
                    </p>
                    <p style={{ fontSize: '0.82rem', color: '#888', margin: '0 0 16px' }}>
                        This will remove the role from all members assigned to it. This cannot be undone.
                    </p>

                    <div style={{ marginBottom: '1rem' }}>
                        <div style={{ fontSize: '0.75rem', color: '#9aa0a6', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.25rem' }}>
                            Type "{roleObj.name}" to confirm
                        </div>
                        <input
                            type="text"
                            className="manage-input"
                            value={deleteText}
                            onChange={e => setDeleteText(e.target.value)}
                            placeholder={roleObj.name}
                            disabled={deleting}
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <button className="btn-cancel" onClick={onClose} disabled={deleting}>Cancel</button>
                        <button
                            className="btn-save"
                            style={{ background: '#c62828', borderColor: '#c62828' }}
                            disabled={deleteText !== roleObj.name || deleting}
                            onClick={handleDelete}
                        >
                            {deleting ? 'Deleting…' : '🗑 Delete'}
                        </button>
                    </div>
                </div>
            </div>

            <InfoModal
                nested
                isOpen={!!error}
                title={error?.title || ''}
                message={error?.message || ''}
                onClose={() => setError(null)}
            />
        </div>
    );
}